var _defs, _path, _path2, _path3, _polygon;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 309.78 111.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#8bb63a;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "WAGO_Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M460.53,293.85v7.09h9.92v6.38H450.61V287.47h42.52V264.79H436.43a8.5,8.5,0,0,0-8.5,8.5v48.19a8.5,8.5,0,0,0,8.5,8.5h48.19a8.5,8.5,0,0,0,8.5-8.5V293.85Z",
    transform: "translate(-256.48 -241.45)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M557.76,264.79H509.57a8.51,8.51,0,0,0-8.5,8.5v48.19a8.5,8.5,0,0,0,8.5,8.5h48.19a8.5,8.5,0,0,0,8.5-8.5V273.29a8.5,8.5,0,0,0-8.5-8.5m-14.17,42.52H523.74V287.47h19.84Z",
    transform: "translate(-256.48 -241.45)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M381.88,264.79l-46.94,72.28h-8.13l10.55,16.25,34.8-16.25H362l12-18.43h23.37V330H420v-65.2Zm-.57,42.52,16-24.64v24.64Z",
    transform: "translate(-256.48 -241.45)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "26.97 88.54 46.63 58.26 46.63 88.54 73.87 88.54 120.81 16.25 128.15 16.25 117.6 0 82.8 16.25 93.52 16.25 69.31 53.53 69.31 23.34 42.27 23.34 22.68 53.51 22.68 23.34 0 23.34 0 88.54 26.97 88.54"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f527405b764c36102e72bfcd74ba25f4.svg";
export { ForwardRef as ReactComponent };